import restApi from "@plannel/services/utils/rest-api";

const get = (params) => {
  return restApi.get("/api/dashboard-kpi", { params });
};

const getDp = (params) => {
  return restApi.get("/api/dashboard-kpi/dp", { params });
}

const getIpModule = (params) => {
  return restApi.get("/api/dashboard-kpi/ip", { params });
}

const getRpModule = (params) => {
  return restApi.get("/api/dashboard-kpi/rp", { params });
}

const dashboardService = {
  get,
  getDp,
  getIpModule,
  getRpModule
};

export default dashboardService;
